export const PWA_MANIFEST_PATH = "/manifest.webmanifest";
export const PWA_SW_PATH = "/sw.js";
export const PWA_THEME_COLOR = "#111111";
export const PWA_BACKGROUND_COLOR = "#111111";
export const PWA_APPLE_TITLE = "MBP";
export const PWA_OFFLINE_PATH = "/offline";

export const PWA_OPERATIONAL_ROUTES = [
  "/dashboard",
  "/dash_agenda",
  "/schedule",
  "/haircuts",
  "/haircuts/new",
  "/clientes",
  "/clientes/novo",
  "/barbers",
  "/planos",
  "/profile",
  "/admin",
] as const;
